module.exports = __webpack_public_path__ + "img/companyIntro22.66f93d3a.png";